// Spójny opis ważności ŚRODKA AUTORYZACJI integracji (token, zgoda AIS, sesja,
// certyfikat, hasło). Zasada wspólna dla wszystkich integracji:
//   • data w przyszłości → „Ważność autoryzacji: do DD.MM.YYYY"
//   • data w przeszłości → „Ważność autoryzacji: DD.MM.YYYY (wygasła)"
//   • środek wydany bezterminowo lub brak daty → „Autoryzacja bezterminowa"
// Wariant `certificate` (integracje na certyfikacie):
//   „Certyfikat do: DD.MM.YYYY" / „Certyfikat do: DD.MM.YYYY (wygasł)"
export function authValidityLabel(opts: {
  validUntil?: string | null;
  indefinite?: boolean;
  certificate?: boolean;
}): string {
  if (!opts.indefinite && opts.validUntil) {
    const d = new Date(opts.validUntil);
    if (!Number.isNaN(d.getTime())) {
      const dateStr = d.toLocaleDateString("pl-PL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      if (opts.certificate) {
        return d.getTime() < Date.now()
          ? `Certyfikat do: ${dateStr} (wygasł)`
          : `Certyfikat do: ${dateStr}`;
      }
      return d.getTime() < Date.now()
        ? `Ważność autoryzacji: ${dateStr} (wygasła)`
        : `Ważność autoryzacji: do ${dateStr}`;
    }
  }
  return "Autoryzacja bezterminowa";
}

// Czy środek autoryzacji wygasł (do wyróżnienia wizualnego).
export function isAuthExpired(validUntil?: string | null): boolean {
  if (!validUntil) return false;
  const d = new Date(validUntil);
  return !Number.isNaN(d.getTime()) && d.getTime() < Date.now();
}
